import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

const ALLOWED_ROLES = ['SuperAdmin', 'Admin', 'BookReviewer'];

export const adminGuard = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.currentUser$.pipe(
    take(1),
    map((user) => {
      if (!auth.isAuthenticated() || !user) {
        router.navigate(['/login']);
        return false;
      }
      if (!ALLOWED_ROLES.includes(user.role)) {
        router.navigate(['/login']);
        return false;
      }
      return true;
    })
  );
};
